import * as FRAGS from "@thatopen/fragments";
import * as OBC from "@thatopen/components";
import * as OBF from "@thatopen/components-front";
import * as WEBIFC from "web-ifc";
import getDecompositionTree from "./getDecompositionTree";
export const computeRowData = async (
    components: OBC.Components,
    models: Iterable<FRAGS.FragmentsGroup>,
    inverseAttributes: OBC.InverseAttribute[],
    expressID?: number,
) => {
    const indexer = components.get(OBC.IfcRelationsIndexer);
    const rows: any[] = [];
    for (const model of (models as FRAGS.FragmentsGroup[])) {
        let modelData: any;
        if (expressID) {
            modelData = {
                data: {
                    Entity: model.name !== "" ? model.name : model.uuid,
                },
                children: await getDecompositionTree(
                    components,
                    model,
                    expressID,
                    inverseAttributes,
                ),
            };
        } else {
            const modelRelations = indexer.relationMaps[model.uuid];
            const projectAttrs = await model.getAllPropertiesOfType(
                WEBIFC.IFCPROJECT,
            );
            if (!(modelRelations && projectAttrs)) continue;
            const { expressID } = Object.values(projectAttrs)[0];
            modelData = {
                data: {
                    Entity: model.name !== "" ? model.name : model.uuid,
                },
                children: await getDecompositionTree(
                    components,
                    model,
                    expressID,
                    inverseAttributes,
                ),
            };
        }
        rows.push(modelData);
    }
    return rows;
};